<template>
    <div class="v-nav-mobile-menu">
        <transition name="fade">
            <div v-show="isOpened">
                <slot>
                    <!---->
                </slot>
            </div>
        </transition>
    </div>
</template>
<script lang="ts">
import { Component } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import BaseComponent from './Base';

const ui = namespace('ui');

@Component
export default class NavMobileMenu extends BaseComponent {
    @ui.State('menuToggled') protected readonly isOpened: boolean;
    @ui.Mutation('toggleMenu') protected toggle: () => void;

    protected hideToggle() {
        this.toggle();
    }
}
</script>

